import GalleryContent from './GalleryContent';

export default GalleryContent;